import { createStore, combineReducers, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk';
import { authReducer } from '../reducers/AuthReducer'
import { msgReducer } from '../reducers/MsgReducer'
import { lineChartReducer } from '../reducers/LineChartReducer'
import { donutChartReducer } from '../reducers/DonutChartReducer';

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||  compose; 

const reducers = combineReducers({
    login: authReducer,
    msgError: msgReducer,
    lineChartReducer: lineChartReducer,
    donutChartReducer: donutChartReducer
})

export const store = createStore(
    reducers,
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() 
    composeEnhancers(
        applyMiddleware( thunk )
    )   
);